import { format, isSameDay } from "date-fns";

export const parseAmPm = (date) => {
  return format(date, "hh:mm a");
};
export const parseDateTimeRange = (dateRangeValue, timeRangeValue) => {
  const { startDate, endDate } = dateRangeValue;
  const { startDate: startTime, endDate: endTime } = timeRangeValue;

  const isSameDayRange = isSameDay(startDate, endDate);
  return isSameDayRange
    ? `${format(startDate, "MMM dd, yyyy")} (${parseAmPm(
        startTime
      )} — ${parseAmPm(endTime)})`
    : `${format(startDate, "MMM dd, yyyy")} (${parseAmPm(
        startTime
      )}) — ${format(endDate, "MMM dd, yyyy")} (${parseAmPm(endTime)})`;
};

export const parseDateTimeDay = (day, timeRange) => {
  return `${format(day, "MMM dd, yyyy")} (${parseAmPm(
    timeRange.startDate
  )} — ${parseAmPm(timeRange.endDate)})`;
};

export const parseDateTimeFromTo = (_date, _time) => {
  return `${format(_date, "yyyy-MM-dd")} ${format(_time, "HH:mm")}`;
};
